import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import PropTypes from "prop-types";

function LineChart({ lineChartData = [], lineChartOptions = {} }) {
  const [series, setSeries]   = useState([]);
  const [options, setOptions] = useState({});

  useEffect(() => {
    setSeries(Array.isArray(lineChartData) ? lineChartData : []);
    setOptions(lineChartOptions || {});
  }, [lineChartData, lineChartOptions]);

  if (series.length === 0) return <div>Loading chart…</div>;

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="area"
      width="100%"
      height="100%"
    />
  );
}

LineChart.propTypes = {
  lineChartData: PropTypes.array,
  lineChartOptions: PropTypes.object,
};

export default LineChart;
